import { ApiProperty } from '../../codegen';
import {
  IsEnum,
  IsString,
  IsDate,
  IsBoolean,
  IsOptional,
  IsObject,
} from '../../validators';
import { EAccountUpdateType } from '../../account';

import { TAchievementId } from './achievements.registry';

export class AchievementDto {
  @ApiProperty()
  @IsString()
  id: TAchievementId;

  @ApiProperty()
  @IsString()
  name: string;

  @ApiProperty()
  @IsString()
  description: string;

  @ApiProperty()
  @IsDate()
  @IsOptional()
  earnedAt?: Date;
}

export class AchievementDeltaDto {
  @ApiProperty()
  @IsEnum(EAccountUpdateType, { groups: ['error'] })
  updateType: EAccountUpdateType.achievement;

  @ApiProperty()
  @IsString()
  achievementId: TAchievementId;

  @ApiProperty()
  @IsDate()
  earnedAt: Date;
}

export class AchievementConfigDto {
  @ApiProperty()
  @IsString()
  id: TAchievementId;

  @ApiProperty()
  @IsString()
  name: string;

  @ApiProperty()
  @IsString()
  description: string;

  @ApiProperty()
  @IsBoolean()
  enabled: boolean;

  @ApiProperty()
  @IsOptional()
  @IsObject()
  conditions?: {
    thresholdSeconds?: number;
    thresholdByGame?: Record<number, number>;
  };
}

export class AchievementReturnDto {
  @ApiProperty()
  @IsString()
  id: TAchievementId;

  @ApiProperty()
  @IsString()
  name: string;

  @ApiProperty()
  @IsString()
  description: string;

  @ApiProperty()
  @IsBoolean()
  enabled: boolean;

  @ApiProperty()
  @IsDate()
  @IsOptional()
  earnedAt?: Date;
}
